import { useRef } from "react";
import AnimatedHeaderSection from "../components/AnimatedHeaderSection";
import { servicesData } from "../constants";
import { useMediaQuery } from "react-responsive";
import { useGSAP } from "@gsap/react";
import gsap from "gsap";

const Services = () => {
  const text = `I build secure, high-performance full-stack apps
with smooth UX.`;

  const serviceRefs = useRef([]);
  const isDesktop = useMediaQuery({ minWidth: "48rem" });

  useGSAP(() => {
    serviceRefs.current.forEach((el) => {
      if (!el) return;

      gsap.from(el, {
        y: 200,
        duration: 1,
        ease: "circ.out",
        scrollTrigger: {
          trigger: el,
          start: "top 80%",
        },
      });
    });
  }, []);

  return (
    <section id="services" className="min-h-screen bg-black rounded-t-4xl">
      <AnimatedHeaderSection
        subTitle="What I Offer"
        title="Services"
        text={text}
        textColor="text-white"
        withScrollTrigger={true}
      />

      {servicesData.map((service, index) => (
        <div
          key={index}
          ref={(el) => (serviceRefs.current[index] = el)}
          className="sticky px-10 pt-6 pb-12 text-white bg-black border-t border-white/20"
          style={
            isDesktop
              ? {
                  top: `calc(10vh + ${index * 5}em)`,
                  marginBottom: `${(servicesData.length - index - 1) * 5}rem`,
                }
              : { top: 0 }
          }
        >
          <div className="flex flex-col gap-8">
            {/* Service Title */}
            <h2 className="text-4xl font-light lg:text-5xl">{service.title}</h2>

            {/* Service Description */}
            <p className="max-w-4xl text-lg leading-relaxed tracking-wide lg:text-xl text-white/60">
              {service.description}
            </p>

            {/* Service Items */}
            <div className="flex flex-col gap-6">
              {service.items.map((item, itemIndex) => (
                <div key={`item-${index}-${itemIndex}`}>
                  <div className="flex items-start gap-8">
                    <span className="min-w-8 text-lg text-white/30">
                      {String(itemIndex + 1).padStart(2, "0")}
                    </span>

                    <div className="flex-1">
                      <h3 className="text-2xl font-medium lg:text-3xl">
                        {item.title}
                      </h3>

                      <p className="mt-2 text-base leading-relaxed text-white/60 lg:text-lg">
                        {item.description}
                      </p>
                    </div>
                  </div>

                  {itemIndex < service.items.length - 1 && (
                    <div className="w-full h-px mt-6 bg-white/20" />
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      ))}
    </section>
  );
};

export default Services;
